// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadfilecontainer {
  height: 200px;
  width: 100%;
  border: 2px dashed var(--theme-main-border-color, #055C8D);
  border-radius: 10px;
}

.drag-drop-label {
  color: gray;
}

.la-cloud-upload-alt {
  font-size: 5rem;
}

.uploadfilecontainer:hover {
  cursor: pointer;
  background-color: #9ecbec !important;
  opacity: 0.8;
}

.files-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px !important;
  font-family: "Inter" !important;
  font-weight: 500 !important;
  width: 100%;
  margin-top: 6px;
  padding: 6px 10px;
  background: #ffffff;
  border: 1px dashed;
  border-radius: 12px;
  color: var(--theme-main-color, #055C8D);
}

.files-list p {
  margin: 0;
}

.files-list .delete-file {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.files-list .delete-file img {
  width: 30px;
}

.la-trash-alt {
  color: red;
}

.uploaded-file-link {
  color: var(--theme-main-color, #055C8D);
  font-family: "Inter" !important;
  font-size: 13px !important;
  font-weight: 500;
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
